// src/services/auditService/adjustmentModes.ts
// Centralized constants for adjustment modes used by audit adjustment flows

export enum AdjustmentMode {
    BREAKDOWM = 0, // SELF(0,"SELF_ADJUSTMENT")
    ADJUST_WP_TO_WP = 1, // WP_TO_WP(1,"WP2WP")
    ADJUST_FS_TO_FS = 2, // FS_OPENING(2,"FS_OPENING")
    ADJUST_WP_TO_FS = 3, // WP_TO_FS_OPENING(3,"WP2FS_OPENING")
    ADJUST_AUTO_GEN = 4, // ADJUST_AUTO_GEN(4,"auto generation adjustment")
    ADJUST_SALE = 5, // ADJUST_SALE(5,"self adjustment")
    ADJUST_SINGLE = 11,
}

export const AdjustmentModeName: Record<AdjustmentMode, string> = {
    [AdjustmentMode.BREAKDOWM]: 'BREAKDOWN',
    [AdjustmentMode.ADJUST_WP_TO_WP]: 'working paper to working paper',
    [AdjustmentMode.ADJUST_FS_TO_FS]: 'finance statement to finance statement',
    [AdjustmentMode.ADJUST_WP_TO_FS]: 'working paper to finance statement',
    [AdjustmentMode.ADJUST_AUTO_GEN]: 'auto generation adjustment',
    [AdjustmentMode.ADJUST_SALE]: 'self adjustment',
    [AdjustmentMode.ADJUST_SINGLE]: 'single',
};
